// extracted by mini-css-extract-plugin
export default {"new_post_button":"styles_new_post_button__1Ij4j","new_post_label":"styles_new_post_label__CEV+m"};